<template>
  <div id="referencje">
    <div class="row margin-both-10 section-whitespace">
      <div class="small-12 medium-offset-2 medium-7 columns">
        <h2 class="big-header">
          KAŻDA OPINIA TO CENNA WSKAZÓWKA NA PRZYSZŁOŚĆ
        </h2>
      </div>
      <div class="small-10 small-offset-2 medium-offset-6 medium-6 large-5 columns">
        <p>
          Dowiedz się jakie korzyści możesz uzyskać dzięki naszej współpracy. Obiecujemy, że wyciągniemy z każdego projektu sto procent jego możliwości. O naszym zaangażowaniu przekonali się już właściciele m.in. takich marek jak: Agata Meble, Energoinstal Katowice, Gwarant Grupa Kapitałowa, Domy Śląskie, Dębowe Tarasy, Adatex.
        </p>
      </div>
    </div>
    <div class="row section-whitespace">
      <div class="small-12 columns">
        <slick class="default-slider" ref="slick" :options="slickOptions">
          <a v-for="(item, index) in items" :key="index" target="_blank" v-if="item._embedded" :href="item._embedded['wp:featuredmedia'][0].media_details.sizes['full'].source_url" class="default-slide">
            <img :src="item._embedded['wp:featuredmedia'][0].media_details.sizes['full'].source_url" :alt="item.title.rendered">
            <h3>{{ item.title.rendered }}</h3>
          </a>
        </slick>
      </div>
    </div>
  </div>
</template>

<script>
import Slick from 'vue-slick'

export default {
  props: ['responsiveItems'],
  data () {
    return {
      items: [],
      slickOptions: {
        slidesToShow: 1,
        arrows: true,
        infinite: false,
        dots: false,
        mobileFirst: true,
        nextArrow: '<button type="button" class="slider__arrow slider__arrow--next"><img src="/static/icons/arrow.svg"></button>',
        prevArrow: '<button type="button" class="slider__arrow slider__arrow--prev"><img src="/static/icons/arrow.svg"></button>',
        responsive: [
          {
            breakpoint: 640,
            settings: {
              slidesToShow: 3
            }
          }
        ]
      }
    }
  },
  components: {
    Slick
  },
  beforeCreate: function () {
    this.$http.get(`wp/v2/references?per_page=100&_embed`).then(response => {
      for (let post in response.data) {
        this.items.push(response.data[post])
      }
    }, error => { console.log(error) })
  },
  beforeUpdate () {
    this.$refs.slick.destroy()
  },
  updated () {
    this.$refs.slick.create()
  }
}
</script>

<style lang="sass">
  @import '../../node_modules/slick-carousel/slick/slick.css';
</style>



// WEBPACK FOOTER //
// src/components/References.vue